import React from 'react';
import Grid from '@mui/material/Grid';
import Avatar from '@mui/material/Avatar';
import AvatarGroup from '@mui/material/AvatarGroup';
import Stack from '@mui/material/Stack';

import locationLogo from '../assets/images/location.svg';
import palmOil from '../assets/images/palmOil.svg';
import getah from '../assets/images/getah.svg';
import padi from '../assets/images/padi.svg';
import luasLadang from '../assets/images/luasLadang.png';
import luasBerhasil from '../assets/images/luasBerhasil.svg';
import luasBertanam from '../assets/images/luasBertanam.svg';
import {numberWithCommas} from '../Helpers/stringFormat';
import {Language} from '../context/LanguageContext';

const DetailData = ({
  data,
  mapRef,
  setPkCode,
  setProjectCode,
  setNegeriCode,
  setMarkerClick,
}) => {
  const {language, newObj} = Language();
  const currentZoom = mapRef?.current?.getZoom();
  const handleCurrentLevelLabel = (zoom) => {
    if (zoom >= 12) {
      return 'Blok';
    } else if (zoom >= 10) {
      return 'Projek';
    } else {
      return 'Pejabat Kawasan';
    }
  };
  const handleCurrentLevelValue = (zoom, item) => {
    if (zoom >= 12) {
      return item.total_features;
    } else if (zoom >= 10) {
      return item.projek;
    } else {
      return item.pejabat_kawasan;
    }
  };
  const handleOnClick = (zoom, item) => {
    if (zoom >= 8 && zoom < 10) {
      setNegeriCode(item.code);
    } else if (zoom >= 10 && zoom < 12) {
      setPkCode(item.code);
    } else if (zoom >= 12) {
      setProjectCode(item.code);
      setMarkerClick(true);
    }
    mapRef.current.flyTo(
      [item.latitude, item.longitude],
      mapRef.current.getZoom() + 2
    );
  };
  return (
    <>
      {data?.length > 0 && (
        <>
          {data.map((item) => (
            <Grid
              container
              component='main'
              key={item.id}
              onClick={() => handleOnClick(currentZoom, item)}
            >
              <Grid
                container
                mt={2}
                mx={2}
                borderRadius='20px 20px 0px 0px'
                sx={{
                  backgroundColor: 'rgba(0,0,0,.2)',
                  height: 'max-content',
                }}
              >
                <Grid
                  container
                  component='main'
                  rowSpacing={1}
                  columnSpacing={{xs: 1, sm: 2, md: 2}}
                  px={2}
                  sx={{
                    paddingY: '10px',
                  }}
                >
                  <Grid
                    item
                    xs={7}
                    //  pb={2}
                    sx={{
                      display: 'flex',
                      alignItems: 'center',
                    }}
                  >
                    <Stack direction='row' spacing={2} alignItems='center'>
                      <Avatar alt='Remy Sharp' src={locationLogo} />
                      <div variant='subtitle1'>
                        {item.title} {item?.code}
                      </div>
                    </Stack>
                  </Grid>
                  <Grid
                    item
                    xs={5}
                    sx={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'end',
                    }}
                  >
                    <AvatarGroup max={4}>
                      {item.jenis_tanaman.sawit && (
                        <Avatar alt='Travis Howard' src={palmOil} />
                      )}
                      {item.jenis_tanaman.getah && (
                        <Avatar alt='Travis Howard' src={getah} />
                      )}
                      {item.jenis_tanaman.padi && (
                        <Avatar alt='Travis Howard' src={padi} />
                      )}
                    </AvatarGroup>
                  </Grid>
                </Grid>
              </Grid>
              <Grid
                container
                px={1}
                py={1}
                mx={2}
                sx={{
                  backgroundColor: 'rgba(0,0,0,.1)',
                  borderRadius: '0px 0px 20px 20px',
                }}
              >
                <Grid container component='main' p={1} py={0}>
                  <Grid item xs={6} display='flex' alignItems='center'>
                    <Stack direction='row' spacing={1} alignItems='center'>
                      <Avatar
                        alt='Luas Ladang'
                        src={luasLadang}
                        sx={{width: 24, height: 24}}
                      />
                      <div style={{fontSize: '10.5px', padding: '2.5px'}}>
                        {newObj.LuasLadangWord[language]}
                      </div>
                    </Stack>
                  </Grid>
                  <Grid item xs={6} display='flex' alignItems='center'>
                    <Stack direction='row' spacing={2} alignItems='center'>
                      <div
                        style={{
                          fontSize: '10.5px',
                          padding: '2.5px',
                          fontWeight: 'bold',
                        }}
                      >
                        {numberWithCommas(item?.luas_ladang_ha)} ha /{' '}
                        {numberWithCommas(item?.luas_ladang_ac)} ac
                      </div>
                    </Stack>
                  </Grid>
                </Grid>
                <Grid container component='main' p={1} py={0}>
                  <Grid item xs={6} display='flex' alignItems='center'>
                    <Stack direction='row' spacing={1} alignItems='center'>
                      <Avatar
                        alt='Luas Bertanam'
                        src={luasBertanam}
                        sx={{width: 24, height: 24}}
                      />
                      <div style={{fontSize: '10.5px', padding: '2.5px'}}>
                        Luas Bertanam
                      </div>
                    </Stack>
                  </Grid>
                  <Grid item xs={6} display='flex' alignItems='center'>
                    <Stack direction='row' spacing={2} alignItems='center'>
                      <div
                        style={{
                          fontSize: '10.5px',
                          padding: '2.5px',
                          fontWeight: 'bold',
                        }}
                      >
                        {numberWithCommas(item?.luas_bertanam)} ha
                      </div>
                    </Stack>
                  </Grid>
                </Grid>
                <Grid container component='main' p={1} py={0}>
                  <Grid item xs={6} display='flex' alignItems='center'>
                    <Stack direction='row' spacing={1} alignItems='center'>
                      <Avatar
                        alt='Luas Berhasil'
                        src={luasBerhasil}
                        sx={{width: 24, height: 24}}
                      />
                      <div style={{fontSize: '10.5px', padding: '2.5px'}}>
                        Luas Berhasil
                      </div>
                    </Stack>
                  </Grid>
                  <Grid item xs={6} display='flex' alignItems='center'>
                    <Stack direction='row' spacing={2} alignItems='center'>
                      <div
                        style={{
                          fontSize: '10.5px',
                          padding: '2.5px',
                          fontWeight: 'bold',
                        }}
                      >
                        {numberWithCommas(item?.luas_berhasil)} ha
                      </div>
                    </Stack>
                  </Grid>
                  <Grid item xs={12} display='flex' alignItems='center'>
                    <div
                      style={{
                        display: 'flex',
                        width: '100%',
                        marginTop: '7px',
                        paddingTop: '7px',
                        borderTop: '1px solid rgba(0,0,0,.2)',
                      }}
                    >
                      <div
                        style={{
                          width: '50%',
                          fontSize: '10.5px',
                        }}
                      >
                        {handleCurrentLevelLabel(currentZoom)}
                      </div>
                      <div
                        style={{
                          width: '50%',
                          fontSize: '10.5px',
                          padding: '2.5px',
                          fontWeight: 'bold',
                          textAlign: 'center',
                          backgroundColor: 'rgba(0,0,0,.2)',
                          borderRadius: '10px',
                        }}
                      >
                        {handleCurrentLevelValue(currentZoom, item)}
                      </div>
                    </div>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          ))}
        </>
      )}
    </>
  );
};

export default DetailData;
